import i18Resource from '@/resources/i18.json'
let currentLanguage = i18Resource;
const language = (v, lang) => {
    let currentLanguageStatus = lang || localStorage.getItem("language") || 'zh'
    let trasValue = ""
    currentLanguage.forEach((item) => {
        if (item.key === v) {
            trasValue = currentLanguageStatus == "zh" ? (item.key.length == 0 ? v : item.key) : item.en;
            return;
        }
    })

    if (trasValue.length > 0) {
        return trasValue;
    }
    
    return v;
}
export default { language }